import { createLazyComponent, LazyModule } from 'owa-bundling';
var lazyModule = new LazyModule(function () {
    return import(/* webpackChunkName: "FavoritePrivateDistributionListNode", webpackPrefetch: true */ './FavoritePrivateDistributionListNode');
});
export var FavoritePrivateDistributionListNodeLazy = createLazyComponent(lazyModule, function (m) { return m.default; });
//# sourceMappingURL=FavoritePrivateDistributionListNodeLazy.js.map